const isUsableSrc = (value) =>
  typeof value === "string" &&
  value.trim() !== "" &&
  (value.startsWith("data:image") || value.startsWith("http://") || value.startsWith("https://"));

/** Hunt/quest join QR — expects data URL from API (see otpQr.util enrich on game/challenge lists). */
export const AdminQrCode = ({ src, otp, label = "join", size = 160 }) => {
  if (isUsableSrc(src)) {
    return (
      <img
        src={src}
        alt={`${label} QR code`}
        width={size}
        height={size}
        style={{ maxWidth: "100%", height: "auto", borderRadius: 8 }}
      />
    );
  }

  if (otp) {
    return (
      <span className="text-muted">
        QR not generated yet for code <strong>{otp}</strong>. Refresh the list or re-save the hunt/quest.
      </span>
    );
  }

  return <span className="text-muted">No join code — QR unavailable</span>;
};

export default AdminQrCode;
